
const serverUrl = process.env.REACT_APP_SERVER_URL;
const serverUrlForIR = process.env.REACT_APP_SERVER_URL_IR_STRUCTURE;

const normalizeUrl = (url) => {
    if (!url) return url;
    if (window.location.protocol === 'https:' && url.startsWith('http:')) {
        return url.replace(/^http:/, 'https:');
    }
    return url;
};

export const environment = {
    SERVER_URL: normalizeUrl(serverUrl),
    SERVER_URL_FOR_IR_STRUCTURE: normalizeUrl(serverUrlForIR),
    BASE_URL: window.location.origin,
};